module.exports = __webpack_public_path__ + "static/media/07.7a2a71fd.jpg";